<template>
  <section class="loginReg" :style="{ '--panelColor': panelColor, '--boxShadow': boxShadow }">
    <div class="loginReg-header-container">
      <div v-html="accessConfig.headerLogo"></div>
    </div>
    <div class="loginReg-container">
      <img class="loginReg-background-img" :src="accessConfig.loginView.bg" />
      <video id="bgvideo" class="loginReg-background-img" playsinline autoplay muted :loop="accessConfig.loginView.loopBGVideo" :poster="accessConfig.loginView.bg" v-if="accessConfig.loginView.bgVideo">
        <source :src="accessConfig.loginView.bgVideo" type="video/mp4" v-if="accessConfig.loginView.bgVideo" />
      </video>
      <div class="loginReg-first-container" v-if="accessConfig.loginView.position == 'right'">
        <transition appear name="translate">
          <div class="loginReg-eventLogo" v-html="accessConfig.loginView.eventLogo"></div>
        </transition>
      </div>
      <div class="loginReg-second-container">
        <div class="loginReg-second-container-header" v-html="accessConfig.loginView.accessContainer"></div>
        <!-- INPUTS -->
        <div class="inputs-wrapper" :key="inputsKey">
          <!-- SELECT -->
          <div v-if="accessConfig.loginView.categorySelector" v-html="accessConfig.loginView.categorySelector.label"></div>
          <div class="general-input-wrapper" v-if="accessConfig.loginView.categorySelector" :class="{ '': !shakeSelector, shakeAnimation: shakeSelector }">
            <select title="" class="general-input is-select" style="margin-right: 8px" required v-model="currentOption.option">
              <option value="" disabled>selecione</option>
              <option v-for="(option, i) in categoryOptions" :key="i" :value="{ option: option.option, passwordUsed: option.passwordUsed, passwordPlaceholder: option.passwordPlaceholder }">{{ option.option }}</option>
            </select>
          </div>
          <!-- USERNAME/EMAIL -->
          <div
            v-if="accessConfig.accessControl && accessConfig.integration != 'cpf' && accessConfig.integration != 'TCS' && accessConfig.integration != 'code' && currentOption.option"
            :class="{ 'email-input-wrapper': !shakeEmail, 'email-input-wrapper shakeAnimation': shakeEmail }">
            <ion-icon class="ionicon-icon" name="mail-outline"></ion-icon>
            <input class="email-input" type="text" :placeholder="accessConfig.loginView.categorySelector ? currentOption.option.passwordPlaceholder : accessConfig.loginView.idPlaceholder" @keypress="checkLogin" v-model="username" />
          </div>
          <!-- CODE -->
          <div v-if="accessConfig.accessControl && accessConfig.integration == 'code'" :class="{ 'email-input-wrapper': !shakeCode, 'email-input-wrapper shakeAnimation': shakeCode }" @keypress="checkLogin">
            <ion-icon class="ionicon-icon" name="card-outline"></ion-icon>
            <input class="general-input" type="text" v-maska="accessConfig.loginView.codeMaskArray" :placeholder="accessConfig.loginView.idPlaceholder ? accessConfig.loginView.idPlaceholder : 'CODE '" id="code" v-model="code" />
          </div>
          <!-- CPF -->
          <div
            v-if="accessConfig.accessControl && (accessConfig.integration == 'cpf' || accessConfig.integration == 'TCS' || accessConfig.integration == 'UNICOCHECK')"
            :class="{ 'cpf-input-wrapper': !shakeCpf, 'cpf-input-wrapper shakeAnimation': shakeCpf }"
            @keypress="checkLogin">
            <ion-icon class="ionicon-icon" name="card-outline"></ion-icon>
            <input class="general-input" type="text" v-maska="['###.###.###-##', '##.###.###/####-##']" placeholder="CPF" id="cpf" v-model="cpf" />
          </div>
          <!-- PASSWORD -->
          <div v-if="accessConfig.accessControl && currentOption.option.passwordUsed" :class="{ 'password-input-wrapper': !shakePassword, 'password-input-wrapper shakeAnimation': shakePassword }">
            <ion-icon class="ionicon-icon" name="lock-closed-outline"></ion-icon>
            <input
              class="general-input"
              type="password"
              id="password"
              :placeholder="accessConfig.loginView.categorySelector ? currentOption.option.passwordPlaceholder : accessConfig.loginView.passwordPlaceholder"
              @keypress="checkLogin"
              v-model="password" />
            <i id="passToggleIcon" class="fa fa-eye-slash passToggleIcon" @click.prevent="togglePasswordView"></i>
          </div>

          <!-- SEND -->
          <button class="enter-and-send-btn" v-if="accessConfig.accessControl" @click.prevent="isChecking ? '' : check()">{{ accessConfig.loginView.accessButton }}</button>
          <!-- GOOGLE LOGIN -->
          <button class="enter-and-send-btn" v-if="accessConfig.accessControl && accessConfig.googleAuth">
            <a v-bind:href="'https://backend.blitzar.com.br/api/event/' + $store.state.eventId + '/google/login?web=' + host">Google login</a>
          </button>
          <!-- <button class="enter-and-send-btn" v-if="accessConfig.accessControl&& accessConfig.googleAuth" @click="showModal">Log In with Google</button> -->

          <!-- BOTTOM INSTRUCTIONS -->
          <div class="bottom-instructions">
            <router-link v-if="accessConfig.accessControl && accessConfig.passwordUsed" class="login-forgot-password" active-class="active" :to="{ name: 'ForgetPassword' }">
              <p v-html="accessConfig.loginView.forgetPasswordText"></p>
            </router-link>
            <div v-if="accessConfig.accessControl && accessConfig.publicSignIn" class="login-signin-first">
              <router-link class="login-click-here" active-class="active" :to="{ name: 'Register' }"><p v-html="accessConfig.loginView.signInText"></p></router-link>
            </div>
          </div>
          <div class="bottom-out-link-container">
            <a class="bottom-out-link" :href="accessConfig.loginView.outLink" target="_blank" v-html="accessConfig.loginView.outText"></a>
          </div>
          <div v-if="accessConfig.loginView.bottomHtml" v-html="accessConfig.loginView.bottomHtml"></div>
        </div>
      </div>
    </div>
    <div class="login-bottom-banner-container" v-if="$store.state.template.banners.enableBanners">
      <!-- <span class="login-banner-sponsor-text" v-if="showBanner">patrocínio:</span> -->
      <Banner style="flex-grow: 0" :bannerSlot="'login_bottom_banner'" @enableBanner="showBanner = true" @disableBanner="showBanner = false" :bannerOverwrite="mat" v-for="mat in banners" :key="mat.banner_idt" />
    </div>
    <div class="footer-wrapper">
      <Footer />
    </div>
  </section>
</template>

<script>
import api from '@/services/api';
import encrypt from '@/services/encrypt';
import Banner from '@/components/banners/Banner.vue';
import Footer from '@/components/general/Footer.vue';
import { maska } from 'maska';
import redirect from '@/services/redirect';

export default {
  name: 'Login',
  components: { Footer, Banner },
  directives: { maska },

  props: { revalidateUser: Boolean, previousRoute: Object },

  data() {
    return {
      username: '',
      password: '',
      cpf: '',
      code: '',
      shakeCpf: false,
      shakeCode: false,
      shakeEmail: false,
      shakePassword: false,
      shakeSelector: false,
      accessConfig: { passwordUsed: false },
      panelColor: 'transparent',
      languageCodeActive: false,
      boxShadow: '0px 0px 40px 0 rgba(0, 0, 0, 0.0)',
      inputsKey: 'cx',
      passwordPlaceholder: 'SENHA',
      categoryOptions: [],
      currentOption: { option: '' },
      showBanner: false,
      banners: [],
      playingBanner: {},
      isChecking: false,
      showLoginExternal: false,
      host: location.protocol + '//' + location.host,
    };
  },

  methods: {
    showModal() {
      // console.log('Show Modal');
      //let element = this.$refs.modal.$el
      //$(element).modal('show')
      this.showLoginExternal = !this.showLoginExternal;
    },
    getApiBannerLogin() {
      let bannerQuery = '?tag=login_bottom_banner';

      api
        .get(`event/${this.$store.state.eventId}/banner${bannerQuery}`)
        .then((response) => {
          // console.log('Banner get beforeMount: ', { response });
          this.banners = response.data.filter((org) => org.material.length);

          let tempBanners = [];
          this.banners.map((org) => {
            org.material.map((banner) => tempBanners.push(banner));
          });

          this.banners = [];
          this.banners = tempBanners.sort((a, b) => (a.sponsor_plan > b.sponsor_plan ? 1 : -1));

          this.$emit('disableBanner');
        })
        .catch((error) => console.error(error));
    },
    checkLogin(key) {
      if (key.keyCode == 13) this.check();
    },
    checkGoogle() {
      api.get(`event/${this.$store.state.eventId}/google/login`).then((response) => {
        // console.log('Login RESPONSE', { response });
        /*this.$store.commit({
          type: 'setUser',
          userData: response.data,
        });*/
      });
      /*      api
      .post(`event/${this.$store.state.eventId}/google/login`, { })
      .then((response) => {
        // console.log('Login RESPONSE', { response });
        this.$store.commit({
          type: 'setUser',
          userData: response.data,
        });
        api
          .post(`event/${this.$store.state.eventId}/commetChat`, { user_id: this.$store.state.user.id })
          .then((res) => {
            // console.log('getchatuser', res);
          })
          .catch((chatError) => {
            console.log('getchatuser error', chatError);
          });

        redirect.redirectAfterLogin(response,this.revalidateUser, this.previousRoute);
      })
      .catch((err, data) => {
        console.log('error', err.response, data);       
          this.shakePassword = true;
          this.shakeEmail = true;
          this.$modal.show('dialog', {
                  title: '',
                  text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                  buttons: [
                    {
                      title: 'Ok',
                      handler: () => {
                        this.$modal.hide('dialog');
                      },
                    },
                  ],
                });
          setTimeout(() => {
            this.shakePassword = false;
            this.shakeEmail = false;
          }, 500);        
      });
  */
    },
    async check() {
      this.$emit('enterClicked');
      this.isChecking = true;
      setTimeout(() => {
        this.isChecking = false;
      }, 2000);
      this.username = this.username.toLowerCase().trim();
      this.password = this.password.trim();
      this.accessConfig.passwordUsed = this.currentOption.option ? this.currentOption.option.passwordUsed : this.accessConfig.passwordUsed;
      if (!this.accessConfig.integration) {
        if (!this.accessConfig.passwordUsed) this.password = this.username;

        if (this.username && this.password) {
          api
            .post(`event/${this.$store.state.eventId}/login`, { email: this.username, password: await encrypt(this.password) })
            .then((response) => {
              // console.log('Login RESPONSE', { response });
              this.$store.commit({
                type: 'setUser',
                userData: response.data,
              });

              // POST MESSAGE
              window.parent.postMessage({ logged: true }, '*');

              redirect.redirectAfterLogin(response, this.revalidateUser, this.previousRoute, this.$modal);
            })
            .catch((err, data) => {
              console.error('error', err.response, data);
              if (err.response?.data.error.includes('Valid process expected')) {
                api
                  .post(`event/${this.$store.state.eventId}/retryValidMail`, {
                    email: this.username,
                  })
                  .then((response) => {
                    this.$modal.show('dialog', {
                      title: '',
                      text: this.accessConfig.loginView.notValidatedMessage
                        ? this.accessConfig.loginView.notValidatedMessage
                        : 'Seu email ainda não foi validado. Um novo email foi disparado para sua conta. Por favor, faça a validação antes de tentar logar novamente.',
                      buttons: [
                        {
                          title: 'Ok',
                          handler: () => {
                            this.$modal.hide('dialog');
                          },
                        },
                      ],
                    });
                  })
                  .catch((err, data) => {
                    console.error('error', err.response, data);
                    this.$modal.show('dialog', {
                      title: '',
                      text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                      buttons: [
                        {
                          title: 'Ok',
                          handler: () => {
                            this.$modal.hide('dialog');
                          },
                        },
                      ],
                    });
                  });
              } else {
                this.shakePassword = true;
                this.shakeEmail = true;
                this.$modal.show('dialog', {
                  title: '',
                  text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                  buttons: [
                    {
                      title: 'Ok',
                      handler: () => {
                        this.$modal.hide('dialog');
                      },
                    },
                  ],
                });
                setTimeout(() => {
                  this.shakePassword = false;
                  this.shakeEmail = false;
                }, 500);
              }
            });
        } else {
          if (!this.currentOption.option) {
            this.shakeSelector = true;
            setTimeout(() => {
              this.shakeSelector = false;
            }, 500);
          }
          if (!this.username) {
            this.shakeEmail = true;
            setTimeout(() => {
              this.shakeEmail = false;
            }, 500);
          }
          if (!this.password) {
            this.shakePassword = true;
            setTimeout(() => {
              this.shakePassword = false;
            }, 500);
          }
        }
      } else {
        if (this.accessConfig.integration === 'code' && !this.accessConfig.passwordUsed) this.password = this.code;
        if (this.accessConfig.integration === 'cpf' && !this.accessConfig.passwordUsed) this.password = this.cpf;
        if (this.accessConfig.integration === 'rdstation' && !this.accessConfig.passwordUsed) this.password = this.username;
        if (this.accessConfig.integration === 'eventBrite' && !this.accessConfig.passwordUsed) this.password = this.username;
        if (this.accessConfig.integration === 'sympla' && !this.accessConfig.passwordUsed) this.password = this.username;
        if (this.accessConfig.integration === 'TCS' && !this.accessConfig.passwordUsed) this.password = this.cpf;
        if (this.accessConfig.integration === 'UNICOCHECK' && !this.accessConfig.passwordUsed) this.password = this.cpf;

        if (this.accessConfig.integration === 'code' && this.code && this.password) {
          api
            .post(`event/${this.$store.state.eventId}/loginCode`, { password: await encrypt(this.password), code: this.code })
            .then((response) => {
              // console.log('loginCode response:', { response });

              this.$store.commit({
                type: 'setUser',
                userData: response.data,
              });
              // this.redirectAfterLogin(response);
              redirect.redirectAfterLogin(response, this.revalidateUser, this.previousRoute, this.$modal);
            })
            .catch((err) => {
              // console.log('error', err, data);
              this.$modal.show('dialog', {
                title: '',
                text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      this.$modal.hide('dialog');
                    },
                  },
                ],
              });
            });
        } else if (this.accessConfig.integration === 'cpf' && this.cpf && this.password) {
          api
            .post(`event/${this.$store.state.eventId}/loginCpf`, { password: await encrypt(this.password), cpf: this.cpf })
            .then((response) => {
              this.$store.commit({
                type: 'setUser',
                userData: response.data,
              });
              // this.redirectAfterLogin(response);
              redirect.redirectAfterLogin(response, this.revalidateUser, this.previousRoute, this.$modal);
            })
            .catch((err, data) => {
              //console.log('integration CPF error, CPF is: ' + this.cpf);
              console.error('error', err.response, data);
              this.$modal.show('dialog', {
                title: '',
                text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      this.$modal.hide('dialog');
                    },
                  },
                ],
              });
            });
        } else if (this.accessConfig.integration === 'rdstation' && this.username && this.password) {
          api
            .post(`event/${this.$store.state.eventId}/rdstation/login`, { password: await encrypt(this.password), email: this.username })
            .then((response) => {
              this.$store.commit({
                type: 'setUser',
                userData: response.data,
              });
              // this.redirectAfterLogin(response);
              redirect.redirectAfterLogin(response, this.revalidateUser, this.previousRoute, this.$modal);
            })
            .catch((err, data) => {
              //console.log('integration CPF error, CPF is: ' + this.cpf);
              console.error('error', err.response, data);
              this.$modal.show('dialog', {
                title: '',
                text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      this.$modal.hide('dialog');
                    },
                  },
                ],
              });
            });
        } else if (this.accessConfig.integration === 'eventBrite' && this.username && this.password) {
          api
            .post(`event/${this.$store.state.eventId}/eventBrite/login`, { password: await encrypt(this.password), email: this.username })
            .then((response) => {
              this.$store.commit({
                type: 'setUser',
                userData: response.data,
              });
              // this.redirectAfterLogin(response);
              redirect.redirectAfterLogin(response, this.revalidateUser, this.previousRoute, this.$modal);
            })
            .catch((err, data) => {
              //console.log('integration CPF error, CPF is: ' + this.cpf);
              console.error('error', err.response, data);
              this.$modal.show('dialog', {
                title: '',
                text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      this.$modal.hide('dialog');
                    },
                  },
                ],
              });
            });
        } else if (this.accessConfig.integration === 'sympla' && this.username && this.password) {
          api
            .post(`event/${this.$store.state.eventId}/sympla/login`, { password: await encrypt(this.password), email: this.username })
            .then((response) => {
              this.$store.commit({
                type: 'setUser',
                userData: response.data,
              });
              // api
              //   .post(`event/${this.$store.state.eventId}/commetChat`, { user_id: this.$store.state.user.id, name: this.$store.state.user.name })
              //   .then(res => {
              //     // console.log('getchatuser', res);
              //   })
              //   .catch(chatError => {
              //     console.error('getchatuser error', chatError);
              //   });
              // this.redirectAfterLogin(response);
              redirect.redirectAfterLogin(response, this.revalidateUser, this.previousRoute, this.$modal);
            })
            .catch((err, data) => {
              //console.log('integration CPF error, CPF is: ' + this.cpf);
              console.error('error', err.response, data);
              this.$modal.show('dialog', {
                title: '',
                text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      this.$modal.hide('dialog');
                    },
                  },
                ],
              });
            });
        } else if (this.accessConfig.integration === 'TCS' && this.cpf && this.password) {
          api
            .post(`event/${this.$store.state.eventId}/checkUser`, { cpf: this.cpf.replace(/\D/g, '') })
            .then((response) => {
              this.$store.commit({
                type: 'setUser',
                userData: response.data,
              });

              // this.redirectAfterLogin(response);
              redirect.redirectAfterLogin(response, this.revalidateUser, this.previousRoute, this.$modal);
            })
            .catch((err, data) => {
              //console.log('integration CPF error, CPF is: ' + this.cpf);
              console.error('error', err.response, data);
              this.$modal.show('dialog', {
                title: '',
                text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      this.$modal.hide('dialog');
                    },
                  },
                ],
              });
            });
        } else {
          if (!this.currentOption.option) {
            this.shakeSelector = true;
            setTimeout(() => {
              this.shakeSelector = false;
            }, 500);
          }
          if (!this.username) {
            this.shakeEmail = true;
            setTimeout(() => {
              this.shakeEmail = false;
            }, 500);
          }
          if (!this.password) {
            this.shakePassword = true;
            setTimeout(() => {
              this.shakePassword = false;
            }, 500);
          }
          if (!this.code) {
            this.shakeCode = true;
            setTimeout(() => {
              this.shakeCode = false;
            }, 500);
          }
          if (this.cpf.length <= 13) {
            this.shakeCpf = true;
            setTimeout(() => {
              this.shakeCpf = false;
            }, 500);
          }
        }
      }
    },
    togglePasswordView() {
      let passToggleIcon = document.getElementById('passToggleIcon');
      let field = document.getElementById('password');

      if (field.type === 'password') {
        field.type = 'text';
        passToggleIcon.classList.remove('fa-eye-slash');
        passToggleIcon.classList.add('fa-eye');
      } else {
        field.type = 'password';
        passToggleIcon.classList.remove('fa-eye');
        passToggleIcon.classList.add('fa-eye-slash');
      }
    },
    randomKey() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    },
  },

  mounted() {
    this.username = this.$store.state.username;
    const grecaptcha = document.querySelector('.grecaptcha-badge');
    // HIDE GOOGLE RECAPTCHA
    if (this.$store.state.template.showRecaptcha) grecaptcha.style.visibility = 'visible';
    else grecaptcha.style.visibility = 'hidden !important';
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    let userLanguage = this.$store.state.user.language ? this.$store.state.user.language.toLowerCase() : 'pt';

    if (this.$store.state.template.multilanguagesConfig) {
      this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${userLanguage}`];
      this.accessConfig.loginFirst = true;
    }

    if (this.accessConfig.loginView.panelColor) this.panelColor = this.accessConfig.loginView.panelColor;
    this.boxShadow = this.accessConfig.loginView.boxShadow ? this.accessConfig.loginView.boxShadow : this.boxShadow;

    if (this.accessConfig.loginView.passwordPlaceholder) this.passwordPlaceholder = this.accessConfig.loginView.passwordPlaceholder;

    this.categoryOptions = this.accessConfig.loginView.categorySelector ? this.accessConfig.loginView.categorySelector.options : [];
    if (!this.accessConfig.loginView.categorySelector) {
      this.currentOption.option = { passwordUsed: this.accessConfig.passwordUsed, passwordPlaceholder: this.accessConfig.loginView.passwordPlaceholder };
    }

    this.getApiBannerLogin();
  },
};
</script>

<style lang="scss">
.loginReg {
  position: absolute;
  inset: 0 0 auto 0;
  background-color: var(--main-color);
  // width: 100vw;
  min-height: calc(100dvh);

  display: flex;
  flex-direction: column;
  align-items: center;
}
.loginReg-container {
  display: flex;
  align-items: center;
  flex-grow: 1;

  #bgvideo {
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    background-size: cover;
  }
}
.loginReg-header-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: var(--headerLogo-position);
  padding: 1%;
  z-index: 10;
}
.loginReg-background-img {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  z-index: 0;
  object-fit: cover;
  padding: 0;
}
.loginReg-first-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  z-index: 1;
  max-width: 600px;
}
.loginReg-eventLogo {
  position: relative;
  min-width: 40vw;
  display: flex;
  justify-content: center;
  img {
    max-width: 100%;
  }
}
.loginReg-second-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 400px;
  height: 100%;
  z-index: 1;
  margin: 2% 6% 4% 2%;
  border-radius: var(--input-borderRadius);
  box-shadow: var(--boxShadow);
  border: 1px solid var(--input-panelBorderColor);
}
.event-login {
  font-size: 1.5rem;
  font-weight: bolder;
  letter-spacing: 1px;
  line-height: 1.3;
}
.inputs-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 4% 5%;
  background-color: var(--panelColor);
  border-bottom-right-radius: var(--input-borderRadius);
  border-bottom-left-radius: var(--input-borderRadius);
  // box-shadow: 0px 22px 20px 0 rgba(0, 0, 0, 0.4);
  // border-radius: var(--input-borderRadius);
  // padding: 5%;
}
.cpf-input-wrapper {
  margin-top: 4%;
  display: flex;
  align-items: center;
  height: 40px;
  min-width: 60%;
  background-color: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--input-borderRadius);

  img {
    padding: 12px;
    width: 40px;
  }
  .cpf-input {
    padding: 1%;
    width: 100%;
    border: 0;
    outline: none;
    color: var(--input-text);
    background-color: transparent;
    &::placeholder {
      color: var(--input-text);
      opacity: 0.8;
    }
  }
}
.email-input-wrapper {
  margin-top: 4%;
  display: flex;
  align-items: center;
  height: 40px;
  min-width: 60%;
  background-color: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--input-borderRadius);

  img {
    padding: 12px;
    width: 40px;
  }
  .email-input {
    padding: 0 10px;
    width: 100%;
    border: 0;
    outline: none;
    color: var(--input-text);
    background-color: transparent;
    &::placeholder {
      color: var(--input-text);
      opacity: 0.8;
    }
  }
}
.password-input-wrapper {
  margin-top: 4%;
  display: flex;
  align-items: center;
  height: 40px;
  min-width: 60%;
  background-color: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--input-borderRadius);

  img {
    padding: 12px;
    width: 40px;
  }
  .password-input {
    padding: 1%;
    width: 100%;
    border: 0;
    outline: none;
    color: var(--input-text);
    background-color: transparent;
    &::placeholder {
      color: var(--input-text);
      opacity: 0.8;
    }
  }
}
.passToggleIcon {
  color: var(--input-text);
}
.enter-and-send-btn {
  position: relative;
  background-color: var(--button-background);
  padding: 1%;
  margin: 4% 0 2% 0;
  height: 40px;
  min-width: 60%;
  width: 100%;
  border: 1px solid var(--button-outline);
  border-radius: var(--input-borderRadius) !important;
  color: var(--button-text);
  font-weight: bold;
  letter-spacing: 0.1rem;
  cursor: pointer;
  outline: none;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.bottom-instructions {
  display: flex;
  flex-direction: column;

  // padding-top: 1%;
  // padding-left: 3%;

  .login-forgot-password {
    margin-top: 2%;
    // text-decoration: underline;
    color: var(--input-text);
  }
  .login-signin-first {
    margin-top: 2%;
    color: var(--input-text);
  }
  .login-click-here {
    // text-decoration: underline;
    color: var(--input-text);
  }
}
.bottom-out-link-container {
  padding-top: 10px;
}
.loginReg-second-container-header {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--text-color);
  width: 100%;
  img {
    max-width: 100% !important;
  }
}
.login-bottom-banner-container {
  position: relative;
  display: flex;
  justify-content: center;

  @include media('<=tablet') {
    bottom: 32px;
    width: 100%;
  }
}
.login-banner-sponsor-text {
  color: var(--secondary-color);
  display: flex;
  justify-content: center;
  width: 100%;
}

@include media('<=tablet') {
  .loginReg-header-container {
    position: relative;
    padding: 2.5% 0 0 2.5%;
  }
  .loginReg-container {
    // flex-grow: 1;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    // height: auto;
    min-height: 97.5vh;
    margin-bottom: 10%;
  }
  .loginReg-first-container {
    width: 90%;
    min-height: 35%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .loginReg-eventLogo {
    img {
      width: auto;
      max-height: 50vh;
      min-height: 200px;
    }
  }
  .loginReg-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    padding: 0;
    width: 80%;
  }
  .loginReg-second-container {
    justify-content: flex-start;
    width: 440px;
    margin: 2%;
  }
  // .login-bottom-banner-container {
  //   // bottom: 40px;
  // }
}

@include media('<=phone') {
  .loginReg-second-container {
    min-width: 220px;
    width: 94%;
  }
  .inputs-wrapper {
    padding: 1% 4%;
  }
}

// Shake animation: alternate;
.shakeAnimation {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 0.5s;
  animation-iteration-count: 1;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
